<template>
  <div class="container-edit-school">
    <a-card :bordered="false">
      <a-tabs :activeKey="tabIndex" @change="onChangeTabs">
        <a-tab-pane tab="学校列表" key="tab_1">
          <div style="padding: 20px 0 40px;">
            <a-select
              v-model="signupId"
              size="large"
              style="width: 180px;margin-right: 10px"
              placeholder="请选择报名"
            >
              <a-select-option
                v-for="item of signupList"
                :value="item.signupNoticeId"
              >{{item.title}}</a-select-option>
            </a-select>
            <a-select
              allowClear
              v-model="street"
              size="large"
              style="width: 180px;margin-right: 10px"
              placeholder="请选择街道"
            >
              <a-select-option
                v-for="(item, index) of streetList"
                :key="index"
                :value="item.code"
              >{{item.name}}</a-select-option>
            </a-select>
            <a-select
              allowClear
              :dropdownMatchSelectWidth="false"
              :notFoundContent="'暂无数据！'"
              v-model="school"
              size="large"
              style="width: 180px;margin-right: 10px"
              placeholder="请选择幼儿园"
            >
              <a-select-option v-for="item of schoolList" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
            <a-button type="primary" size="large" icon="search" @click="ajaxGetSchoolList({page:1})">
              搜索
            </a-button>

          </div>
          <div>
            <a-table :columns="columns"  :pagination="false" :dataSource="tableData" rowKey="id">
              <template slot="action" slot-scope="text, record">
                <a class="text-operator" @click.prevent="editSchool(record)">[修改]</a>
                <!--<a class="text-operator" @click.prevent="deleteSchool(record.id)">[删除]</a>-->
              </template>
              <template slot="schoolType" slot-scope="text, record">
               {{text===1?'公办园':'普惠性民办园'}}
              </template>
            </a-table>
            <div style="margin-top: 10px">
              <a-pagination
                style="float: right"
                show-size-changer
                v-model="page.page"
                :page-size.sync="page.size"
                :total="page.total"
                @change="handlePageChange"
                @showSizeChange="handlePageChange"
              />
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="修改学校" disabled key="tab_2">
          <div style="padding-top: 24px;">
            <a-form :form="form">

              <a-form-item label="学校名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                <a-input
									:disabled="disabled"
                  v-decorator="['name',
                    {rules: [{ required: true, message: '报名标题不能为空!' }]}
                  ]"/>
              </a-form-item>

              <a-form-item label="所属街道/镇乡" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                <a-select
									:disabled="disabled"
                  placeholder="请选择"
                  v-decorator="['streetCode',
                    {rules: [{ required: true, message: '请选择所属街道!' }]}
                  ]">
                  <a-select-option v-for="item of streetList" :value="item.code">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>

							<a-form-item label="所属街道社区" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" v-show="currentVillageNames.length">
								<span>{{currentVillageNames.join('，')}}</span>
              </a-form-item>

              <a-form-item label="学校性质" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                <a-select
                  placeholder="请选择"
                  v-decorator="['schoolType',
                    {rules: [{ required: true, message: '请选择学校性质!' }]}
                  ]">
                  <a-select-option :value="1">公办园</a-select-option>
                  <a-select-option :value="2">普惠性民办园</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="计划招生人数" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                <a-input-number
									:min="0"
									style="width: 120px;"
									placeholder="请输入数字"
                  v-decorator="['studentNum',
                    {rules: [{ required: true, message: '请输入招生人数（只能输入整数）！' }]}
                  ]"/>
              </a-form-item>
              <a-form-item label="学校招生简介" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                <a-textarea
                  placeholder="小于20000字"
                  :rows="8"
                  v-decorator="['introduction',
                    {rules: [
                    { required: true, message: '招生简介不能为空!' },
                    {max:20000,message:'不超过20000字！'}
                    ]}
                  ]">
                </a-textarea>
              </a-form-item>

              <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
                <a-button size="large" type="primary" @click="handleSubmit">提 交</a-button>
              </a-form-item>

              <a-form-item>
                <a-input v-decorator="['id']" hidden />
              </a-form-item>
              <a-form-item>
                <a-input v-decorator="['streetName']" hidden />
              </a-form-item>
            </a-form>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
  import config from '../../../config/index';
	import Cookies from 'js-cookie';
	import UpfileButton from '../../../sxui/components/upload/UpfileButton';
  import AdminCommon from './mixins/admin_common';

	const columns = [{
    title: '序号',
    dataIndex: 'index'
  }, {
    title: '学校名称',
    dataIndex: 'name'
  },{
    title: '学校性质',
    dataIndex: 'schoolType',
    scopedSlots: { customRender: 'schoolType' }
  }, {
    title: '计划招生人数',
    dataIndex: 'studentNum'
  }, {
  //   title: '所在街道',
  //   dataIndex: 'streetName'
  // }, {
    title: '操作',
    scopedSlots: { customRender: 'action' }
	}];

  export default {
		components: { UpfileButton },
		mixins: [],
    data() {
      return {
        studentType: this.$store.state.systemLevel === 'kinder' ? 1 : (this.$store.state.systemLevel === 'school' ? 2 : 0),
				acceptType: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				fileUrl: '',


        signupId: undefined,
        signupList: [],
        street:undefined,
        streetList:[],
        school:undefined,
        schoolList:[],
        schoolType:undefined,

        tableData:[],

        page:{
          "page":1,
          "size": 10,
          total:0
        },

				token: Cookies.get(config.cookie.name),
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				config,
        tabIndex: 'tab_1',
        formSearch: this.$form.createForm(this),
        form: this.$form.createForm(this),
				// 当前修改的学校社区列表
				currentVillageNames: [],
        columns,

				currentModel: 'add' // edit 编辑 add 删除
      };
    },
		computed: {
			disabled() {
				return this.currentModel === 'edit';
			}
		},
    watch:{
      signupId:{
        handler(val){
          if(val){
            // 获取通知id后获取幼儿园列表
            this.getKinderSchoolData();
          }
        }
      },
      street:{
        handler(val){
          if(val){
            // 获取通知id后获取幼儿园列表
            this.getKinderSchoolData();
          }
        }
      }
    },
    async created() {
			await this.ajaxGetSignupList();
			await this.getStreetList();
			await this.ajaxGetSchoolList();
    },
    methods: {
      handlePageChange(page, pageSize){
        this.page.page = page
        this.page.size = pageSize
        this.ajaxGetSchoolList()
      },
      handleSizeChange(page, pageSize){
        this.page.page = 1
        this.page.size = pageSize
        this.ajaxGetSchoolList()
      },
      async ajaxGetSignupList() {
        let {data} = await this.$ajax.gateway("/bm-kids/ISignupNoticeApi_querySignupNotices", {
          studentType: this.studentType
        })
        // 处理获取的报名列表数据
        if (data.code===200) {
          data = data.data
          if (typeof data === "object" && data.length > 0) {
            this.signupList = data;
            this.signupId = this.signupList[0].signupNoticeId
          }
        }


      },
      async getStreetList(){
        let {data} = await this.$ajax.gateway("/bm-kids/IAreaApi_getMyAreas", {
          studentType: this.studentType
        })
        let areaData = data;

        if (
          areaData.code === 200 &&
          typeof areaData.data === "object" &&
          areaData.data.length
        ) {
          this.$store.commit("setStreetList", areaData.data);
          this.streetList = areaData.data;

        }
      },
      async getKinderSchoolData(params) {
        let { data } = await this.fetchKinderSchool(params);
        this.schoolList = data;
        this.school = undefined
      },
      // 获取幼儿园列表
      async fetchKinderSchool(args) {
        if(!this.signupId) return
        // 报名端-根据街道CODE查询幼儿园列表 #李茹钰/2020-06-02#
        let {data,error} = await this.$ajax.gateway("/bm-kids/ISchoolApi_searchSchoolByAreaCode_1", {
          "METHOD": "get",
          signupNoticeId: this.signupId,
          streetCode :this.street,
        });

        if (data) {
          return data;
        } else {
          this.$message.error('获取学校列表失败！');
          return { data: null };
        }
      },
			onBeforeUpload(file) {
				console.log('上传之前', file);

				if (this.acceptType.indexOf(file.type) < 0) {
					this.$message.error('只能上传格式为xls或xlsm的表格文件！');
					return false;
				}

				if (file.size > 1024 * 5) {
					this.$message.error('请上传小于5M的文件！');
					return false;
				}

				return true;
			},

			onUploadSuccess(data) {
				console.log('上传成功', data);
			},

			onUploadError(data) {
				console.log('arguments', data);
				this.$message('上传失败')
			},

			async fetchStreetVillage() {
				// 查询出当前用户对应区域的的街道列表和街道对应的学校列表 #李茹钰/2019-03-12#
				let { data } = await this.$ajax.gateway('/bm-kids/IAreaApi_getMyAreas', {
					studentType: this.studentType
				});
				this.$ajax.gateway('/bm-kids/IAreaApi_getMyAreas', {
						studentType: this.studentType
					})

				console.log('街道学校列表------', data);

				if (data && data.data) {
					this.streetList = data.data;
				}
			},

      // onChangeStreet(value) {
      //   // 街道选择发生了变化
			// 	console.log('-> onChangeStreet', value);
			// 	this.formSearch.setFieldsValue({ 'villageCode': undefined });
			// 	this.ajaxGetSchoolList(value);
      //
			// 	let currentStreet = this.streetList.find(v => v.code == value);
			// 	if (currentStreet) {
			// 		this.villageList = currentStreet.children;
			// 	}
			// },

			onChangeVillage(value) {
				this.ajaxGetSchoolList();
			},

			uniq(array, key = 'id') {
				var temp = []; // 一个新的临时数组

				array.forEach(item => {
					if (!temp.find(v => v[key] === item[key])) {
							temp.push(item);
					}
				});

				return temp;
			},

      async ajaxGetSchoolList(page) {

        let {signupId:signupNoticeId,street:streetCode,school:schoolId} = this
        if(!signupNoticeId) return

        // 根据街道CODE查询学校列表 #李茹钰/2019-03-12#
        let { data } = await this.$ajax.gateway('/bm-kids/ISchoolApi_querySchool_1', {
          schoolId,
          signupNoticeId,
					streetCode,
          body:{
            pageableDto:{
              ...this.page,
              ...page
            },
            schoolId,
            signupNoticeId,
            streetCode,
          }
				});

        if (data.code === 200) {
					data = data.data;
					this.page.total = data.totalCount
					// data = this.uniq(data.dataList);

          this.tableData = data.dataList.map((item,index)=>{
            return {
              ...item.areaSchoolVillageVO,
              index:index+1
            }
          })
          console.log(this.tableData)
        }
      },
      editSchool(item) {
        console.log('-> editSchool', item);
        console.log('-> editSchool', item.name);

        this.tabIndex = 'tab_2';
				this.currentModel = 'edit';
				this.setFormFields(item);
				this.currentVillageNames = item.villageNames;
      },
      setFormFields(item) {
        console.log('-> setFormFields', item);
        let formVal = {};
        ['name', 'streetCode', 'studentNum', 'introduction', 'id', 'streetName','schoolType'].forEach(field => {
          formVal[field] = item[field];
        });
        setTimeout(() => {
          this.form.setFieldsValue(formVal);
        }, 10);
      },
      // deleteSchool(id) {
      //   console.log('-> deleteSchool id', id);
      //   this.$confirm({
      //     title: '删除学校',
      //     content: '你确定删除这个学校么？',
      //     okText: '确认',
      //     cancelText: '取消',
      //     onOk: () => {
      //       this.ajaxDeleteSchool(id);
      //     }
      //   });
			// },
      onChangeTabs(tab) {
        if (tab === 'tab_2') {
					this.currentModel = 'add';
          this.form.resetFields();
          console.log('-> this.formSearch.getFieldsValue().street', this.formSearch.getFieldsValue().street);
          this.setFormFields({
            streetCode: this.formSearch.getFieldsValue().street
          });
        }
        this.tabIndex = tab;
			},

			onChangeUpload(info) {
				if (info.file.status !== 'uploading') {
					console.log(info.file, info.fileList);
				}
				if (info.file.status === 'done') {
					this.$message.success(`${info.file.name} file uploaded successfully`);
				} else if (info.file.status === 'error') {
					this.$message.error(`${info.file.name} file upload failed.`);
				}
			},

			handleDownloadTemplate() {
				// let url = '/api/school/download/school_template.xlsx' + '?token=' + Cookies.get(config.cookie.name);
				// window.open(config.web.staticHost + url, '_blank');
				window.open('https://sxjy-oss-v2.oss-cn-hangzhou.aliyuncs.com/lq-bm/school_template.xlsx', '_blank');
			},

      async handleSubmit() {
        this.form.validateFields(err => {
          if (err) return;

          let formVal = this.form.getFieldsValue();
          console.log('-> handleSubmit formVal', formVal);
          let params = {
            signupNoticeId:this.signupId ,
            introduction: formVal.introduction,
            name: formVal.name,
						streetName: formVal.streetName,
            streetCode: formVal.streetCode,
            studentNum: formVal.studentNum,
            schoolType: formVal.schoolType
          };
          if (formVal.id) params.id = formVal.id;
          if (formVal.streetCode) {
            params.streetName = this.streetList.find(item => Number(formVal.streetCode) === Number(item.code)).name;
          }
          console.log('-> handleSubmit params', params);
          this.ajaxUpdateSchool(params);
        });
      },
      async ajaxUpdateSchool(params) {
        // 添加或更新学校 #李茹钰/2019-03-13#
        let { data } = await this.$ajax.gateway('/bm-kids/ISchoolApi_addUpdateSchool_1', { body: params });
        if (data.code === 200 && data.data) {
          this.$message.success('保存成功');
          this.onChangeTabs('tab_1');
          this.ajaxGetSchoolList();
        } else {
          this.$message.warning('保存失败');
        }
      },
      async ajaxDeleteSchool(schoolId) {
        console.log('-> ajaxDeleteSchool', schoolId);
        // 删除学校 #李茹钰/2019-03-14#
        let { data } = await this.$ajax.gateway('/bm-kids/ISchoolApi_deleteSchool', { schoolId });
        console.log('-> ', data);
        if (data.code === 200 && data.data) {
          this.$message.success('删除成功');
          this.schoolListDeleteRow(schoolId, 'id');
        } else {
          this.$message.warning(data.message || '删除失败');
        }
      },
      schoolListDeleteRow(value, key) {
        // 删除行
        const tableData = [...this.tableData];
        this.tableData = tableData.filter(item => item[key] !== value);
      }
    }
  };
</script>

<style lang="stylus" scoped>
	.container-edit-school
		>>> .ant-tabs-nav-wrap
			.ant-tabs-tab:nth-child(2):hover
				cursor not-allowed
				color rgba(0, 0, 0, 0.65);
</style>
